// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StartForm_wrapper__xQyG9","form":"StartForm_form___IdyD"};